import React from 'react'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { Document } from '@contentful/rich-text-types'
import { BundleT } from '@/common/types'
import { BUNDLE_COPY } from '@/locales/en'
import ReadMore from '@/common/ui/read-more'
import { ANALYTICS_EVENTS } from '@/common/analytics/events'
import { analytics } from '@/common/analytics/analytics'
import { H2 } from '@/common/ui/h2'

type Props = {
    bundle?: BundleT
}

export const BundleAboutLoading: React.FC = () => (
    <div className="w-full flex flex-col justify-start items-start gap-6">
        <div className="self-stretch inline-flex justify-start items-center gap-2.5">
            <div className="h-6 bg-stone-100 rounded w-1/3 animate-pulse" />
        </div>
        <div className="w-full animate-pulse">
            <div className="h-4 bg-stone-100 rounded w-3/4 mb-3" />
            <div className="h-3 bg-stone-100 rounded w-full mb-2" />
            <div className="h-3 bg-stone-100 rounded w-full mb-2" />
            <div className="h-3 bg-stone-100 rounded w-5/6" />
        </div>
        <div className="w-full animate-pulse">
            <div className="h-3 bg-stone-100 rounded w-1/2 mb-2" />
        </div>
    </div>
)

export const BundleAbout: React.FC<Props> = ({ bundle }) => {
    if (!bundle) {
        return <BundleAboutLoading />
    }

    const onReadMoreClick = (open: boolean) => {
        analytics.trackWithDefaults(ANALYTICS_EVENTS.TRADING.BUNDLE_ABOUT_READ_MORE_CLICKED, {
            bundle_id: bundle.slug,
            show_more: open,
        })
    }

    return (
        <div className="self-stretch flex flex-col justify-start items-start gap-6">
            <div className="self-stretch flex flex-col justify-start items-start gap-6">
                <H2 className="text-center justify-start text-black text-3xl font-normal font-['Serious Sans'] leading-10 mb-0">
                    {BUNDLE_COPY.about}
                </H2>
                <ReadMore
                    className="self-stretch flex flex-col justify-start items-start text-black text-base font-normal font-['Inter'] gap-6"
                    onOpenChange={onReadMoreClick}
                >
                    {documentToReactComponents(bundle.description as Document)}
                </ReadMore>
            </div>
        </div>
    )
}

export default BundleAbout
